const g2 = require('../g2')
const RenderUtil = {};
/**
 * 
 */
RenderUtil.emptyFeatureCol = function() {
    return {
        "type": "FeatureCollection",
        "features": []
    };
}

/** 
 * 
 */
RenderUtil.featureSet2GeoJson = function(featureSet) {
    let featureCol = this.emptyFeatureCol();
    for (let i = 0; i < featureSet.getCount(); i++) {
        let feature = featureSet.getFeature(i);
        let featureObj = {};
        featureObj.id = feature.objectId;
        featureObj.geometry = feature.geometry.asGeoJson();
        featureObj.properties = {};
        for (let j = 0; j < feature.fields.getCount(); j++) {
            let field = feature.fields.getField(j).name;
            let value = feature.getValue(field);
            featureObj.properties[field] = value;
        }
        featureCol.features.push(featureObj);
    }
    return featureCol;
}

/** 
 * 
 */
RenderUtil.getFeatureById = function(id, featureSet) {
    let resultObj = {};
    resultObj.feature = null;
    resultObj.index = -1;
    for (let j = 0; j < featureSet.getCount(); j++) {
        if (id == featureSet.getFeature(j).objectId) {
            resultObj.index = j;
            resultObj.feature = featureSet.getFeature(j);
            break;
        }
    }
    return resultObj;
}

/** 
 * 
 */
RenderUtil.createFields = function(fieldNames, fieldAlias) {
    let fields = new g2.sfs.Fields();
    for (let j = 0, len = fieldNames.length; j < len; j++) {
        let field = new g2.sfs.Field({
            name: fieldNames[j],
            alias: fieldAlias[j]
        });
        fields.add(field);
    }
    return fields;
}

module.exports = RenderUtil;